import "./AddAutomation.scss";
import AddAutomationCard from "./AddAutomationCard/AddAutomationCard";
import AddAutomationCardEmpty from "./AddAutomationCard/AddAutomationCardEmpty";
import { useIcon } from "@SeemplicityDev/shared";
import { AutomationUseCase } from "./AddAutomation";

export type onCardClickType = (
  type: AutomationUseCase["endpoint_type"],
  automationType?: AutomationUseCase["automation_type"],
  automationId?: AutomationUseCase["id"]
) => void;

type AddAutomationSectionProps = {
  label: string;
  useCases: AutomationUseCase[];
  showEmptyState?: boolean;
  showIntegrations?: boolean;
  onCardClick: onCardClickType;
};

const AddAutomationSection: React.FC<AddAutomationSectionProps> = ({
  label,
  useCases,
  showEmptyState = false,
  showIntegrations = true,
  onCardClick,
}) => {
  const hasValid = useCases.some((useCase) => useCase.valid);
  const { getDataSourceIcon } = useIcon();

  return (
    <div
      className="add-automation-section"
      data-testid="add-automation-section"
    >
      <h3>{label}</h3>
      <ul className="use-cases-options">
        {showEmptyState && !hasValid && <AddAutomationCardEmpty />}
        {useCases?.map((useCase) => (
          <li key={useCase.id}>
            <AddAutomationCard
              icon={useCase.icon}
              title={useCase.title}
              disabled={!useCase.valid}
              onClick={() =>
                onCardClick(
                  useCase.endpoint_type,
                  useCase.automation_type,
                  useCase.id
                )
              }
              description={useCase.description}
              showIntegrations={showIntegrations}
              integrations={useCase?.integrations?.map((intergration) => {
                const icon = getDataSourceIcon(intergration.type, "S");
                return {
                  displayName: intergration.friendly_name,
                  logo: typeof icon === "string" ? icon : "", // This check prevents moving DataSourceIcon type forward since it is not accepted by EntityList and EnitityIten
                };
              })}
              labels={useCase.labels}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AddAutomationSection;
